import React, { useState, useEffect } from 'react';
import { getDirectoryTree } from '../../api';
import { useNavigate } from 'react-router';
import {
  FolderOutlined,
  FileOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import { 
  message, 
  Tree,
  Card,
  Tooltip,
} from 'antd';
import './TreeView.css';

const TreeView = () => {
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const loadTreeData = async () => {
    try {
      setLoading(true);
      const tree = await getDirectoryTree();
      // console.log(tree);
      const treeNodes = convertToAntdTreeData([tree]);
      // console.log('treeNodes 2', treeNodes);
      setTreeData(treeNodes);
      // Set initial expanded keys to show root
      setExpandedKeys(['']);
    } catch (err) {
      message.error(
        err.response?.data?.error || 'Failed to load directory tree'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadTreeData();
  }, []);

  const convertToAntdTreeData = (nodes) => {
    const treeNodes = nodes.map(node => {
      const nodeData = {
        title: renderTreeNodeTitle(node),
        key: node.path,
        isLeaf: !node.isDirectory,
        fileId: node.fileId,
        isAnalyzed: node.isAnalyzed,
        isAllowedFile: node.isAllowedFile,
        isDirectory: node.isDirectory,
        children: node.children ? convertToAntdTreeData(node.children) : undefined,
      };
      return nodeData;
    });
    return treeNodes;
  };

  const renderTreeNodeTitle = (node) => {
    if (node.isDirectory) {
      return (
        <span className="tree-node-title">
          {node.name}
          {node.children && (
            <span className="tree-node-count">
              ({node.children.filter(child => !child.isDirectory && child.isAllowedFile).length} files)
            </span>
          )}
        </span>
      );
    } else {
      return (
        <span className="tree-node-title">
          <span className="tree-file-name">{node.name}</span>
          {node.isAnalyzed && (
            <Tooltip title="File has been analyzed">
              <CheckCircleOutlined className="tree-analyzed-icon" />
            </Tooltip>
          )}
          {node.fileId && !node.isAnalyzed && (
            <Tooltip title="Analysis in progress">
              <ClockCircleOutlined className="tree-pending-icon" />
            </Tooltip>
          )}
        </span>
      );
    }
  };

  const handleTreeSelect = (selectedKeys, info) => {
    const selectedNode = info.node;
    setSelectedKeys(selectedKeys);
    console.log(selectedNode);
    if (!selectedNode.isDirectory && selectedNode.isAllowedFile) {
      if (selectedNode.fileId) {
        const filepath = selectedNode.key;
        navigate(`/analysis?filepath=${encodeURIComponent(filepath)}`);
      } else {
        message.info('This file has not been analyzed yet, please try later.');
      }
    }
  };

  const handleTreeExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  return (
    <div className="tree-view">
      <Card className="tree-view-card">
        <Tree
          showIcon
          selectedKeys={selectedKeys}
          expandedKeys={expandedKeys}
          onSelect={handleTreeSelect}
          onExpand={handleTreeExpand}
          treeData={treeData}
          className="folder-tree"
          loading={loading}
          showLine={true}
        />
      </Card>
    </div>
  );
};

export default TreeView; 